import styled, { css } from 'styled-components';
import { getDefaultTransition, getColorAlias, getSpacing, getFontSize, getDarkenColor, transparentizeAliasColor } from '../../utils/index.js';

const SpinnerWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ContentWrapper = styled.span ``;
const Button = styled.button `
  display: block;
  font-family: ${(props) => props.theme.font.familyPrimary};
  font-weight: ${(props) => props.theme.font.weightBold};
  letter-spacing: ${(props) => props.theme.font.letterSpacing02};
  border-radius: ${(props) => props.theme.radius.roundedE};
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
  width: ${(props) => (props.fullWidth ? '100%' : 'fit-content')};
  margin: 0 2px;
  ${getDefaultTransition()};

  &:hover {
    cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};
  }

  &:disabled {
    background-color: ${getColorAlias('disabled01')};
    color: ${getColorAlias('contentDisabled')};
  }

  &:disabled:hover {
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    border: 2px solid ${getColorAlias('focus')};
  }

  & > * {
    pointer-events: none;
  }

  ${ContentWrapper} {
    align-items: center;
    display: ${({ isLoading }) => (isLoading ? 'none' : 'grid')};
    gap: ${getSpacing('s02')};
    grid-auto-flow: column;
    grid-gap: ${getSpacing('s02')};
    justify-content: center;

    svg {
      ${getDefaultTransition()};
    }
  }
`;
const ButtonLarge = styled(Button) `
  min-height: 56px;
  padding: 14px ${getSpacing('s05')};
  ${getFontSize('size20')};
`;
const ButtonMedium = styled(Button) `
  min-height: 48px;
  padding: 10px ${getSpacing('s05')};
  ${getFontSize('size20')};
`;
const ButtonSmall = styled(Button) `
  min-height: 40px;
  padding: ${getSpacing('s02', 's04')};
  ${getFontSize('size16')};
`;
const ButtonXSmall = styled(Button) `
  min-height: 32px;
  padding: ${getSpacing('s01', 's02')};
  ${getFontSize('size14')};

  ${ContentWrapper} {
    padding: ${getSpacing('s00', 's02')};
  }
`;
function setButtonStates(alias) {
    return css `
    &:hover {
      background-color: ${getDarkenColor('hover02', alias)};
    }
    &:active {
      background-color: ${getDarkenColor('active02', alias)};
    }
  `;
}
function setButtonTransparentStates(alias) {
    return css `
    &:hover {
      background-color: ${transparentizeAliasColor('hover02', alias)};
    }
    &:active {
      background-color: ${transparentizeAliasColor('active02', alias)};
    }
  `;
}

export { ButtonLarge, ButtonMedium, ButtonSmall, ButtonXSmall, ContentWrapper, SpinnerWrapper, setButtonStates, setButtonTransparentStates };
